var _filter, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgModalClose = function SvgModalClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    width: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "modal-close_svg__a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 48,
    width: 48,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1510_7854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1510_7854",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#modal-close_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 40,
    rx: 20,
    width: 40,
    x: 4,
    y: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6 13.413a1.36 1.36 0 0 0-1.924 0L24 20.075 17.324 13.4c-.532-.532-1.392-.532-1.925 0s-.532 1.393 0 1.925L22.075 22 15.4 28.676c-.532.532-.532 1.392 0 1.925s1.393.532 1.925 0L24 23.925l6.676 6.676c.532.532 1.392.532 1.925 0s.532-1.393 0-1.925L25.925 22l6.676-6.676a1.368 1.368 0 0 0 0-1.911z",
    fill: "#333"
  }))));
};

export { SvgModalClose as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjQ4IiB2aWV3Qm94PSIwIDAgNDggNDgiIHdpZHRoPSI0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGZpbHRlciBpZD0iYSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGhlaWdodD0iNDgiIHdpZHRoPSI0OCIgeD0iMCIgeT0iMCI+PGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz48ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHJlc3VsdD0iaGFyZEFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiLz48ZmVPZmZzZXQgZHk9IjIiLz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIyIi8+PGZlQ29tcG9zaXRlIGluMj0iaGFyZEFscGhhIiBvcGVyYXRvcj0ib3V0Ii8+PGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAuMTIgMCIvPjxmZUJsZW5kIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiBtb2RlPSJub3JtYWwiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93XzE1MTBfNzg1NCIvPjxmZUJsZW5kIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvd18xNTEwXzc4NTQiIG1vZGU9Im5vcm1hbCIgcmVzdWx0PSJzaGFwZSIvPjwvZmlsdGVyPjxnIGZpbHRlcj0idXJsKCNhKSI+PHJlY3QgZmlsbD0iI2ZmZiIgaGVpZ2h0PSI0MCIgcng9IjIwIiB3aWR0aD0iNDAiIHg9IjQiIHk9IjIiLz48cGF0aCBkPSJtMzIuNjAwNyAxMy40MTNjLS41MzI0LS41MzI1LTEuMzkyNS0uNTMyNS0xLjkyNDkgMGwtNi42NzU4IDYuNjYyMS02LjY3NTgtNi42NzU4Yy0uNTMyNC0uNTMyNC0xLjM5MjUtLjUzMjQtMS45MjQ5IDBzLS41MzI0IDEuMzkyNSAwIDEuOTI0OWw2LjY3NTggNi42NzU4LTYuNjc1OCA2LjY3NThjLS41MzI0LjUzMjQtLjUzMjQgMS4zOTI1IDAgMS45MjQ5czEuMzkyNS41MzI0IDEuOTI0OSAwbDYuNjc1OC02LjY3NTggNi42NzU4IDYuNjc1OGMuNTMyNC41MzI0IDEuMzkyNS41MzI0IDEuOTI0OSAwcy41MzI0LTEuMzkyNSAwLTEuOTI0OWwtNi42NzU4LTYuNjc1OCA2LjY3NTgtNi42NzU4Yy41MTg4LS41MTg3LjUxODgtMS4zOTI1IDAtMS45MTEyeiIgZmlsbD0iIzMzMyIvPjwvZz48L3N2Zz4=";